module.exports = __webpack_public_path__ + "img/proyecto_8_mv.903907c8.webp";